import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './BlogPage.css';

const BlogPage = ({ onSelectPost }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const blogRef = ref(database, 'blog');
    const unsubscribe = onValue(blogRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setPosts(list.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0)));
      } else {
        setPosts([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div className="blog-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Blog</h1>
          <p className="page-hero-subtitle">Yazılar ve güncel içerikler</p>
        </div>
      </div>
      <div className="blog-page-content">
        <div className="container">
          {loading ? (
            <div className="blog-loading"><p>Yükleniyor...</p></div>
          ) : posts.length === 0 ? (
            <div className="blog-empty"><p>Henüz blog yazısı eklenmemiş.</p></div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => (
                <article
                  key={post.id}
                  className="blog-card blog-card-clickable"
                  onClick={() => onSelectPost && onSelectPost(post.id)}
                  onKeyDown={(e) => e.key === 'Enter' && onSelectPost && onSelectPost(post.id)}
                  role="button"
                  tabIndex={0}
                >
                  <h3 className="blog-card-title">{post.title}</h3>
                  {post.date && <time className="blog-card-date">{formatDate(post.date)}</time>}
                  <p className="blog-card-excerpt">{post.excerpt || post.content}</p>
                  {onSelectPost && <span className="blog-card-read-more">Devamını oku →</span>}
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
